import { gql } from '@apollo/client';

export interface TimeSlotsAvailableQueryResponse {
  hasTimeSlots: boolean;
}

export const TIMESLOTS_AVAILABLE_QUERY = gql`
  query appointmentsAvailable(
    $appointmentTypeId: Int!
    $labId: Int
    $locationId: Int
    $startDateTime: String!
    $providerId: Int
    $endDateTime: String
  ) {
    hasTimeSlots(
      appointmentTypeId: $appointmentTypeId
      labId: $labId
      locationId: $locationId
      startDateTime: $startDateTime
      providerId: $providerId
      endDateTime: $endDateTime
    )
  }
`;
